import {Component, inject, input, InputSignal} from '@angular/core';
import {ControlValueAccessor, FormsModule, NgControl, ReactiveFormsModule} from "@angular/forms";
import {TranslateModule} from "@ngx-translate/core";
import {CommonModule} from '@angular/common';


@Component({
    selector: 'app-switch',
    templateUrl: './app-switch.component.html',
    styleUrls: ['./app-switch.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        TranslateModule
    ]
})
export class AppSwitchComponent implements ControlValueAccessor {
    label: InputSignal<string> = input.required();
    description: InputSignal<string> = input('');
    containerStyles: InputSignal<string> = input('');
    inputValue: boolean = false;

    // Setup
    private ngControl = inject(NgControl, {optional: true});
    protected onTouched?: () => {};
    protected onChange?: (value: boolean) => {};
    protected isDisabled = false;

    constructor() {
        if (this.ngControl) this.ngControl.valueAccessor = this;
    }

    writeValue(obj: any): void {
        this.inputValue = obj;
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.isDisabled = isDisabled;
    }

}
